export const loginUser = async (email, password) => {
  const response = await fetch(`/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, password }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || 'Ошибка входа');
  }

  return await response.json();
};

export const registerUser = async (username, email, password) => {
  const response = await fetch(`/auth/register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ username, email, password }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || 'Ошибка регистрации');
  }

  return await response.json();
};

export const getMe = async (token) => {
  const response = await fetch(`/auth/me`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Ошибка получения данных пользователя');
  }

  return await response.json();
};

export const deleteUser = async (token) => {
  try {
    const response = await fetch('/auth/me', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Ошибка при удалении аккаунта');
    }

    return await response.json();
  } catch (error) {
    console.error('Ошибка удаления аккаунта:', error);
    throw error;
  }
};
